import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Table } from 'antd';
const ProductFamilyModal = (props) => {
    const columns = [
        {
            key: '1',
            title: 'Product Model (Series Model)',
            dataIndex: 'strSeriesModel',
            width: '30%'
        },
        {
            key: '2',
            title: 'Brand/OEM',
            dataIndex: ['objBrandName', 'strLongDesc'],
            width: '30%'
        },
        {
            key: '3',
            title: 'Factory / Importer / OEM',
            dataIndex: 'strFactoryName',
            width: '30%'
        },
        {
            key: '4',
            title: 'Factory Address',
            dataIndex: 'strFactoryAddress',
            width: '30%'
        },
        {
            key: '5',
            title: 'Remarks',
            dataIndex: 'strRemarks',
            width: '30%'
        }
    ];
    let checkedList = [];
    const hColumns = columns.map((item) => {
        if (props.isRemark) {
            checkedList = ['1', '2', '3', '4', '5'];
        }
        else {
            checkedList = ['1', '2'];
        }
        return Object.assign(Object.assign({}, item), { hidden: !checkedList.includes(item.key) });
    });
    return (_jsx(Modal, { title: "Product Family Information", width: 1000, open: props.open, onCancel: props.onClose, footer: null, children: _jsx(Table, { columns: hColumns, dataSource: props.productFamilyList.map((item, index) => (Object.assign(Object.assign({}, item), { key: index }))) }) }));
};
export default ProductFamilyModal;
